'use client';

import { motion } from 'framer-motion';
import { useLabTabStore } from '@/stores/useLabTabStore';
import { LAB_TAB_CATEGORIES } from '@/constants/constants';
import { LabType } from '@/types/labs';
import LabBadge from '@/components/features/lab/LabBadge';

export default function LabTabSwitcher() {
    const selectedTab = useLabTabStore((s) => s.selectedTab);
    const setSelectedTab = useLabTabStore((s) => s.setSelectedTab);
    const activeIndex = LAB_TAB_CATEGORIES.findIndex((tab) => tab.type === selectedTab);

    return (
        <div className="relative bg-gray-100 rounded p-1 min-w-full h-[40px]">
            <div className="grid grid-cols-3 relative w-full h-full text-center">
                <motion.div
                    className="absolute bg-white rounded shadow w-1/3 h-full"
                    animate={{ x: `${activeIndex * 100}%` }}
                    transition={{ duration: 0.5, ease: 'easeInOut' }}
                />
                {LAB_TAB_CATEGORIES.map((labTab) => (
                    <div
                        key={labTab.type}
                        className="z-10 relative flex justify-center items-center w-full cursor-pointer h-full"
                        onClick={() => setSelectedTab(labTab.type)}
                    >
                        <div
                            className={`px-1 font-corp ${
                                selectedTab === labTab.type
                                    ? 'font-bold text-color-base text-xs md:text-base'
                                    : 'font-medium text-gray-400 text-xs md:text-sm'
                            }`}
                        >
                            {labTab.label}
                        </div>
                        <div>
                            <LabBadge labType={labTab.type as LabType} baseWidth={20} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
